import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { useIntl } from 'react-intl';
import { StationAuditPage } from '../../components/StationAuditPage';
import { MatchesRootView } from './MatchesRootView';

export function StationMatchesListPage() {
  const station = useActiveStation();
  const { $t } = useIntl();

  return (
    <StationAuditPage
      title={$t({
        id: 'audit.matchesScreen.title',
        defaultMessage: 'Resultados',
      })}
    >
      <MatchesRootView station={station} />
    </StationAuditPage>
  );
}
